/**
 * @generated SignedSource<<c9f19e5dcffb1484aa60a758da012fbb>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ECommerce = "AMAZON" | "API" | "BIG_COMMERCE" | "CODE_CANYON" | "C_CLOUD" | "ETSY" | "MAGENTO" | "MAGENTO1" | "NET_SUITE" | "NONE" | "OPEN_CART" | "PRESTA_SHOP" | "SHOPIFY" | "SHOPWARE" | "WIX" | "WOO_COMMERCE";
export type templateCatalogQuery$variables = {
  productId: string;
};
export type templateCatalogQuery$data = {
  readonly model: {
    readonly additionalCodes: ReadonlyArray<{
      readonly code: string;
      readonly merchantProductName: string;
      readonly salesChannel: {
        readonly ecommerceSettings: {
          readonly ecommerceName: ECommerce;
          readonly remoteUrl: string | null;
        } | null;
      };
      readonly salesChannelID: string;
    }>;
    readonly code: string;
    readonly colors: ReadonlyArray<{
      readonly code: string | null;
      readonly colorID: number;
      readonly colorProviderCode: string | null;
      readonly name: string;
      readonly position: number;
    }>;
    readonly id: string;
    readonly merchantProductConnectedOptions: ReadonlyArray<{
      readonly isGlobal: boolean;
      readonly label: string;
      readonly optionID: string;
      readonly salesChannelID: number;
      readonly sku: string | null;
      readonly values: ReadonlyArray<{
        readonly label: string;
        readonly valueID: string;
      }>;
    }>;
    readonly name: string;
    readonly salesChannel: {
      readonly ecommerceSettings: {
        readonly ecommerceName: ECommerce;
      } | null;
    };
    readonly salesChannelID: string;
    readonly statusID: number;
  } | null;
  readonly salesChannels: ReadonlyArray<{
    readonly ecommerceSettings: {
      readonly definitiveUrl: string | null;
      readonly ecommerceID: number;
      readonly ecommerceName: ECommerce;
      readonly hasProductsApi: boolean;
      readonly isMarketplace: boolean;
      readonly remoteUrl: string | null;
    } | null;
    readonly id: string;
  }>;
};
export type templateCatalogQuery = {
  response: templateCatalogQuery$data;
  variables: templateCatalogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productId"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "ignoreNoneECommerce",
    "value": true
  },
  {
    "kind": "Literal",
    "name": "status",
    "value": "ACTIVE"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceID",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasProductsApi",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMarketplace",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remoteUrl",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "definitiveUrl",
  "storageKey": null
},
v9 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "productId"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusID",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salesChannelID",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "merchantProductName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "Color",
  "kind": "LinkedField",
  "name": "colors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "colorID",
      "storageKey": null
    },
    (v11/*:: as any*/),
    (v12/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "colorProviderCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "position",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "MerchantProductGraphQLOption",
  "kind": "LinkedField",
  "name": "merchantProductConnectedOptions",
  "plural": true,
  "selections": [
    (v13/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sku",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "optionID",
      "storageKey": null
    },
    (v16/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGlobal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MerchantProductGraphQLOptionValue",
      "kind": "LinkedField",
      "name": "values",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "valueID",
          "storageKey": null
        },
        (v16/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "templateCatalogQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SalesChannel",
        "kind": "LinkedField",
        "name": "salesChannels",
        "plural": true,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EcommerceSettings",
            "kind": "LinkedField",
            "name": "ecommerceSettings",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "salesChannels(ignoreNoneECommerce:true,status:\"ACTIVE\")"
      },
      {
        "alias": null,
        "args": (v9/*:: as any*/),
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "model",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v10/*:: as any*/),
          (v11/*:: as any*/),
          (v12/*:: as any*/),
          (v13/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SalesChannel",
            "kind": "LinkedField",
            "name": "salesChannel",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EcommerceSettings",
                "kind": "LinkedField",
                "name": "ecommerceSettings",
                "plural": false,
                "selections": [
                  (v4/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductCode",
            "kind": "LinkedField",
            "name": "additionalCodes",
            "plural": true,
            "selections": [
              (v12/*:: as any*/),
              (v13/*:: as any*/),
              (v14/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesChannel",
                "kind": "LinkedField",
                "name": "salesChannel",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EcommerceSettings",
                    "kind": "LinkedField",
                    "name": "ecommerceSettings",
                    "plural": false,
                    "selections": [
                      (v4/*:: as any*/),
                      (v7/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v15/*:: as any*/),
          (v17/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "templateCatalogQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SalesChannel",
        "kind": "LinkedField",
        "name": "salesChannels",
        "plural": true,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EcommerceSettings",
            "kind": "LinkedField",
            "name": "ecommerceSettings",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/),
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "salesChannels(ignoreNoneECommerce:true,status:\"ACTIVE\")"
      },
      {
        "alias": null,
        "args": (v9/*:: as any*/),
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "model",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v10/*:: as any*/),
          (v11/*:: as any*/),
          (v12/*:: as any*/),
          (v13/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SalesChannel",
            "kind": "LinkedField",
            "name": "salesChannel",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EcommerceSettings",
                "kind": "LinkedField",
                "name": "ecommerceSettings",
                "plural": false,
                "selections": [
                  (v4/*:: as any*/),
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductCode",
            "kind": "LinkedField",
            "name": "additionalCodes",
            "plural": true,
            "selections": [
              (v12/*:: as any*/),
              (v13/*:: as any*/),
              (v14/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesChannel",
                "kind": "LinkedField",
                "name": "salesChannel",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EcommerceSettings",
                    "kind": "LinkedField",
                    "name": "ecommerceSettings",
                    "plural": false,
                    "selections": [
                      (v4/*:: as any*/),
                      (v7/*:: as any*/),
                      (v2/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v15/*:: as any*/),
          (v17/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "949b2ef5daddcd0c02413872371d2c81",
    "id": null,
    "metadata": {},
    "name": "templateCatalogQuery",
    "operationKind": "query",
    "text": "query templateCatalogQuery(\n  $productId: ID!\n) {\n  salesChannels(status: ACTIVE, ignoreNoneECommerce: true) {\n    id\n    ecommerceSettings {\n      ecommerceID\n      ecommerceName\n      hasProductsApi\n      isMarketplace\n      remoteUrl\n      definitiveUrl\n      id\n    }\n  }\n  model(id: $productId) {\n    id\n    statusID\n    name\n    code\n    salesChannelID\n    salesChannel {\n      ecommerceSettings {\n        ecommerceName\n        id\n      }\n      id\n    }\n    additionalCodes {\n      code\n      salesChannelID\n      merchantProductName\n      salesChannel {\n        ecommerceSettings {\n          ecommerceName\n          remoteUrl\n          id\n        }\n        id\n      }\n    }\n    colors {\n      colorID\n      name\n      code\n      colorProviderCode\n      position\n    }\n    merchantProductConnectedOptions {\n      salesChannelID\n      sku\n      optionID\n      label\n      isGlobal\n      values {\n        valueID\n        label\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d87e0e4204d7fa098efb18c49cdf8e20";

export default node;
